import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { COOKIE_TOKEN } from "redux/authentication";
import * as cookies from "ultis/cookies";

const SERVER_BASE_URL = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}`;

export const reportAxios = axios.create({
  baseURL: `${SERVER_BASE_URL}/report-cloud-pbx`,
});

reportAxios.interceptors.request.use(function (config) {
  config.headers.Authorization = `${cookies.get(COOKIE_TOKEN)}`;
  return config;
});

reportAxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.config.disabledNotification) {
      return Promise.reject(error);
    }
    let errorMessage = "Có lỗi xảy ra";
    if (typeof error.response?.data?.msg === "string")
      errorMessage = error.response.data.msg;
    enqueueSnackbar(errorMessage, {
      variant: "error",
    });
    return Promise.reject(error);
  }
);

export const httpClient = axios.create({
  baseURL: SERVER_BASE_URL,
});

httpClient.interceptors.request.use(function (config) {
  config.headers.Authorization = `${cookies.get(COOKIE_TOKEN)}`;
  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorMessage =
      error.response?.data?.error?.message || "Có lỗi xảy ra";
    enqueueSnackbar(errorMessage, {
      variant: "error",
    });
    return Promise.reject(error);
  }
);
